import React, {
  EventHandler,
  KeyboardEvent,
  MouseEvent,
  ReactNode,
  useCallback,
  forwardRef,
} from 'react';

import { classNames } from '../../utils/style';

export interface TitleAndParagraphTabProps {
  selected: boolean;
  title?: string;
  picto?: any;
  onClick?: EventHandler<MouseEvent | KeyboardEvent>;
  className?: string;
  children?: ReactNode;
}

export const TitleAndParagraphTab = forwardRef(
  (
    {
      selected = false,
      onClick,
      className,
      children,
    }: TitleAndParagraphTabProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const handleKeyDown = useCallback(
      (event: KeyboardEvent) => {
        if (event.key === 'Enter' && onClick) onClick(event);
      },
      [onClick],
    );

    return (
      <div
        ref={ref}
        role={'button'}
        tabIndex={0}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        className={classNames(
          'TitleAndParagraphTab',
          className,
          selected
            ? 'opacity-100'
            : 'transition ease-out duration-500 opacity-50',
          'hover:opacity-100 focus:opacity-100',
          'tab flex flex-col items-center cursor-pointer',
          'outline-none h-full',
        )}
      >
        {children}
      </div>
    );
  },
);